import { useNftx } from '@nftx/react';
import { Address } from 'nftx.js';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../queryKeys';

const usePositions = (
  {
    userAddress,
    vaultId,
  }: {
    userAddress?: Address;
    vaultId?: string;
  },
  opts?: { enabled?: boolean }
) => {
  const {
    network,
    core: { fetchLiquidityPositions, fetchInventoryPositions },
  } = useNftx();
  const enabled = !!((userAddress || vaultId) && opts?.enabled !== false);

  return useQuery(
    [QueryKey.POSITIONS, network, userAddress, vaultId],
    async () => {
      const ip = await fetchInventoryPositions({
        network,
        userAddress,
        vaultId,
      });
      const lp = await fetchLiquidityPositions({
        network,
        userAddress,
        vaultId,
      });

      return [ip, lp] as const;
    },
    { enabled }
  );
};

export default usePositions;
